// extracted by mini-css-extract-plugin
module.exports = {"logo":"Navbar_logo__37KXr","navbar":"Navbar_navbar__3XuRG"};